import React from "react";
import monsterlogo from "./pantry-monster.png";

class InputForm extends React.Component {
  render() {
    const highLightInput = this.props.inputHighlight ? "input-highlight" : "";

    // console.log("InputForm", this.props);
    return (
      <div className="input-form">
        <div className="accordion " id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                <img className="monster" src={monsterlogo} />
                Add An Item To Inventory
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <form
                  name="item-input-form"
                  id="item-input-form"
                  className="container"
                  onSubmit={this.props.onSubmit}
                >
                  <div className="row text-sm m-1">
                    <div className="text-start">
                      Select from previous store inventory to repopulate a
                      previously stocked item (remember to set the quantity!) or
                      add a brand new item.
                    </div>

                    <select
                      id="existing-item"
                      name="existing-item"
                      onChange={this.props.onItemSelect}
                    >
                      <option key="0" id="0" value="--">
                        --
                      </option>
                      {this.props.items.map((x) => {
                        return (
                          <option
                            key={x.id}
                            id={x.id}
                            value={JSON.stringify(x)}
                            name={x.id}
                          >
                            {x.productName} [{x.productSize} {x.productSizeUnit}
                            ]
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <input
                    type="hidden"
                    id="productId"
                    name="productId"
                    value={this.props.selId}
                    onChange={this.props.onFormUpdate}
                  />

                  <div className="row text-sm">
                    <div className="col-5">
                      <label htmlFor="productName" className="">
                        Product Name
                      </label>
                      <input
                        id="productName"
                        className="form-control form-control-sm"
                        name="productName"
                        value={this.props.selName}
                        onChange={this.props.onFormUpdate}
                      />
                    </div>

                    <div className="col">
                      <label htmlFor="productSize" className="">
                        Size
                      </label>
                      <input
                        id="productSize"
                        className="form-control form-control-sm"
                        name="productSize"
                        value={this.props.selSize}
                        onChange={this.props.onFormUpdate}
                      />
                    </div>

                    <div className="col">
                      <label htmlFor="productSizeUnit" className="">
                        Unit
                      </label>

                      <select
                        id="productSizeUnit"
                        className="input-unit form-control form-control-sm"
                        name="productSizeUnit"
                        onChange={this.props.onFormUpdate}
                        value={this.props.selUnit}
                      >
                        <option value="none">No unit</option>
                        <option value="oz">oz</option>
                        <option value="grams">grams</option>
                        <option value="lbs">lbs</option>{" "}
                      </select>
                    </div>

                    <div className="col">
                      <label htmlFor="count" className="">
                        Count
                      </label>
                      <input
                        name="count"
                        className={
                          "form-control form-control-sm " + highLightInput
                        }
                        id="count"
                        onChange={this.props.onFormUpdate}
                        value={this.props.selCount}
                      />
                    </div>

                    <div className="col">
                      <label htmlFor="upc" className="">
                        UPC
                      </label>
                      <input
                        name="UPC"
                        className="form-control form-control-sm"
                        id="upc"
                        value={this.props.selUPC}
                        onChange={this.props.onFormUpdate}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col col-1">
                      <button
                        name="submit"
                        disabled={this.props.status}
                        type="submit"
                        className="btn btn-sm btn-success"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col col-1">
                      <button
                        name="reset"
                        onClick={this.props.onReset}
                        className="btn btn-sm btn-danger"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InputForm;
